import { api, API_ENDPOINTS } from '../lib/api';

interface MessageResponse {
  message: string;
}

export const otpService = {
  /**
   * Send OTP for registration email verification
   */
  sendRegistrationOtp: async (email: string): Promise<MessageResponse> => {
    const response = await api.post<MessageResponse>(API_ENDPOINTS.AUTH.SEND_OTP, {
      email,
      purpose: 'registration',
    });
    return response.data;
  },

  /**
   * Send OTP for email update (requires auth)
   */
  sendEmailUpdateOtp: async (email: string): Promise<MessageResponse> => {
    const response = await api.post<MessageResponse>(API_ENDPOINTS.AUTH.SEND_EMAIL_OTP, {
      email,
    });
    return response.data;
  },

  /**
   * Verify OTP and update email (requires auth)
   */
  verifyEmailUpdateOtp: async (email: string, code: string): Promise<MessageResponse> => {
    const response = await api.post<MessageResponse>(API_ENDPOINTS.AUTH.VERIFY_EMAIL_OTP, {
      email,
      code,
    });
    return response.data;
  },

  /**
   * Request password reset OTP
   */
  requestPasswordReset: async (email: string): Promise<MessageResponse> => {
    const response = await api.post<MessageResponse>(API_ENDPOINTS.AUTH.REQUEST_PASSWORD_RESET, {
      email,
    });
    return response.data;
  },

  /**
   * Confirm password reset with OTP
   */
  confirmPasswordReset: async (
    email: string,
    code: string,
    newPassword: string,
    confirmPassword: string,
  ): Promise<MessageResponse> => {
    const response = await api.post<MessageResponse>(API_ENDPOINTS.AUTH.CONFIRM_PASSWORD_RESET, {
      email,
      code,
      newPassword,
      confirmPassword,
    });
    return response.data;
  },

  /**
   * Change password (requires auth + current password)
   */
  changePassword: async (
    currentPassword: string,
    newPassword: string,
    confirmPassword: string,
  ): Promise<MessageResponse> => {
    const response = await api.post<MessageResponse>(API_ENDPOINTS.AUTH.CHANGE_PASSWORD, {
      currentPassword,
      newPassword,
      confirmPassword,
    });
    return response.data;
  },
};
